var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rect',{attrs:{"x":"0","y":"0","width":"100%","height":this.height,"fill":"url(#stroke-pattern)","id":"lava"}})
}
var staticRenderFns = []

export { render, staticRenderFns }